import { render } from "./TrackerCreateSecondStep.vue?vue&type=template&id=22df4495"
import script from "./TrackerCreateSecondStep.vue?vue&type=script&lang=js"
export * from "./TrackerCreateSecondStep.vue?vue&type=script&lang=js"
script.render = render

export default script